import { render, staticRenderFns } from "./PaperManage.vue?vue&type=template&id=94aa6b70&scoped=true"
import script from "./PaperManage.vue?vue&type=script&lang=js"
export * from "./PaperManage.vue?vue&type=script&lang=js"
import style0 from "./PaperManage.vue?vue&type=style&index=0&id=94aa6b70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94aa6b70",
  null
  
)

export default component.exports